import { StreamLanguage, HighlightStyle, syntaxHighlighting } from "@codemirror/language"
import { tags as t } from "@lezer/highlight"

const KEYWORD_SET = new Set([
  "FROM", "WHERE", "KEEP", "DROP", "STATS", "SORT", "LIMIT", "RENAME", "CORRELATE", "EVAL",
  "AND", "OR", "NOT", "IS", "NULL", "BETWEEN", "LIKE", "RLIKE", "IN", "BY", "AS", "ASC", "DESC",
])

const FUNCTION_SET = new Set([
  "COUNT", "COUNT_DISTINCT", "AVG", "MAX", "MIN", "SUM", "PERCENTILE",
  "TO_LOWER", "TO_UPPER", "STARTS_WITH", "ENDS_WITH", "CONTAINS", "CIDR_MATCH", "MATCH",
  "ABS", "ROUND", "FLOOR", "CEIL", "LENGTH", "DATE_TRUNC",
])

export const esqlLanguage = StreamLanguage.define({
  token(stream) {
    if (stream.eatSpace()) return null

    if (stream.match(/"(?:[^"\\]|\\.)*"/)) return "string"

    if (stream.match("//")) { stream.skipToEnd(); return "comment" }

    if (stream.match("/*")) {
      while (!stream.eol()) {
        if (stream.match("*/")) break
        stream.next()
      }
      return "comment"
    }

    if (stream.match(/\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/)) return "number"

    if (stream.match(/[a-zA-Z_][a-zA-Z0-9_.#]*/)) {
      const word = stream.current().toUpperCase()
      if (KEYWORD_SET.has(word)) return "keyword"
      if (FUNCTION_SET.has(word)) return "builtin"
      return null
    }

    if (stream.match(/==|!=|>=|<=|[|<>]/)) return "operator"

    stream.next()
    return null
  },
})

const esqlHighlightStyle = HighlightStyle.define([
  { tag: t.keyword,                  color: "var(--color-esql-keyword, #569cd6)" },
  { tag: t.standard(t.name),         color: "var(--color-esql-function, #4ec9b0)" },
  { tag: t.string,                   color: "var(--color-esql-string, #ce9178)" },
  { tag: t.number,                   color: "var(--color-esql-number, #b5cea8)" },
  { tag: t.comment,                  color: "var(--color-esql-comment, #6a9955)", fontStyle: "italic" },
  { tag: t.operator,                 color: "var(--color-esql-operator, #d4d4d4)" },
])

export const esqlSyntaxHighlighting = syntaxHighlighting(esqlHighlightStyle)
